export var DashboardPermissions;
(function (DashboardPermissions) {
    DashboardPermissions["CanRead"] = "canRead";
    DashboardPermissions["CanEdit"] = "canEdit";
    DashboardPermissions["CanReadCsm"] = "canReadCsm";
})(DashboardPermissions || (DashboardPermissions = {}));
//# sourceMappingURL=permissions.js.map